import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Layout as DefaultLayout, AppBar, UserMenu, MenuItemLink } from 'react-admin';
import { Link, withRouter } from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import ListSubheader from '@material-ui/core/ListSubheader';
import SecurityIcon from '@material-ui/icons/Security';
import { withStyles } from '@material-ui/core/styles';
import { fetchMyTotpStatus } from '../api';

class CustomUserMenuImpl extends Component {
  state = { username: null };
  async componentDidMount() {
    try {
      const { data } = await fetchMyTotpStatus();
      if (data.username) this.setState({ username: data.username });
    } catch (e) {
      // silent
    }
  }
  render() {
    const { username } = this.state;
    return (
      <UserMenu {...this.props} label={username || 'Profile'}>
        {username && <ListSubheader disableSticky>Signed in as {username}</ListSubheader>}
        <MenuItemLink
          to="/2fa-settings"
          primaryText="Two-factor authentication"
          leftIcon={<SecurityIcon />}
        />
      </UserMenu>
    );
  }
}
const CustomUserMenu = CustomUserMenuImpl;

const CustomAppBar = props => <AppBar {...props} userMenu={<CustomUserMenu />} />;

const styles = theme => ({
  banner: {
    backgroundColor: theme.palette.warning ? theme.palette.warning.main : '#ff9800',
    color: '#000',
  },
});

class TwoFactorBanner extends Component {
  state = { dismissed: false, totpEnabled: true, ready: false };

  componentDidMount() {
    this.refresh();
  }

  componentDidUpdate(prevProps) {
    const prevPath = prevProps.location && prevProps.location.pathname;
    const currPath = this.props.location && this.props.location.pathname;
    if (prevPath !== currPath) {
      this.refresh();
    }
  }

  refresh = async () => {
    try {
      const { data } = await fetchMyTotpStatus();
      this.setState({ ready: true, totpEnabled: data.totpEnabled });
    } catch (e) {
      this.setState({ ready: true });
    }
  };

  handleDismiss = () => this.setState({ dismissed: true });

  render() {
    const { classes, location } = this.props;
    const { ready, totpEnabled, dismissed } = this.state;
    if (!ready || totpEnabled || dismissed) return null;
    if (location && location.pathname === '/2fa-settings') return null;
    if (location && location.pathname === '/login') return null;
    return (
      <Snackbar
        open
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        style={{ top: 64 }}
      >
        <SnackbarContent
          className={classes.banner}
          message="Your account is not protected by 2FA. Enable it to keep client data secure. You can always turn it on later from the user menu in the top-right corner."
          action={[
            <Button key="enable" color="inherit" size="small" component={Link} to="/2fa-settings">
              Enable 2FA
            </Button>,
            <Button key="dismiss" color="inherit" size="small" onClick={this.handleDismiss}>
              Later
            </Button>,
          ]}
        />
      </Snackbar>
    );
  }
}

TwoFactorBanner.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object,
};

const StyledTwoFactorBanner = withRouter(withStyles(styles)(TwoFactorBanner));

const Layout = props => (
  <React.Fragment>
    <DefaultLayout {...props} appBar={CustomAppBar} />
    <StyledTwoFactorBanner />
  </React.Fragment>
);

export default Layout;
